import { render } from "./StoreClientContact.vue?vue&type=template&id=1bb4fd39&scoped=true"
import script from "./StoreClientContact.vue?vue&type=script&lang=js"
export * from "./StoreClientContact.vue?vue&type=script&lang=js"

import "./StoreClientContact.vue?vue&type=style&index=0&id=1bb4fd39&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb4fd39"]])

export default __exports__